import { useLayoutEffect, useRef } from 'react';

/**
 * Прокрутка списка, на месте которого в той же панели открывается карточка.
 *
 * Панель не меняется, и VKUI прокрутку не ведёт: карточка открывалась на
 * высоте строки, а закрытый список вставал там, где его обрезало окно.
 * Прокручивается само окно — `AppRoot` в режиме `full` держит прокрутку на
 * `window`.
 *
 * Возвращённую функцию зовут ДО открытия: карточка короче списка, и после
 * подмены браузер уже урезал бы позицию. Открытая карточка встаёт сверху,
 * закрытая возвращает список на запомненное место до первой отрисовки: строки
 * на месте сразу, их держат хуки секции.
 */
export function useCardScroll(open: boolean): () => void {
  const saved = useRef(0);
  const shown = useRef(open);

  useLayoutEffect(() => {
    // Монтирование — не открытие: секцию собирают и с уже открытой карточкой.
    if (shown.current === open) return;
    shown.current = open;
    window.scrollTo(0, open ? 0 : saved.current);
  }, [open]);

  return () => {
    saved.current = window.scrollY;
  };
}
